/* eslint-disable no-prototype-builtins */

import PropTypes from 'prop-types';
import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import {
  RouteHandler,
  ScrollWidgetActions,
  ShopViewConstants
} from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';
import Fetching from '../Fetching';
import ProductGroupItem from '../ProductGroupItem';
import ErrorMessage from '../ErrorMessage';
import { ProductStarRating } from '../Yotpo';
import BottomLinks from '../BottomLinks';
import NoProducts from '../NoProducts';
import { YotpoCSS, hideEmptyStars } from '../utils/YotpoUtils';
import { mapContextToProps } from '../BaseContainerContext';

export class ClassicLayout extends React.Component {
  constructor() {
    super(...arguments);
    this.handleClickViewAll = this.handleClickViewAll.bind(this);
  }

  componentDidUpdate() {
    /* eslint-disable no-undef */
    if (typeof yotpo !== 'undefined') {
      setTimeout(() => {
        const checkMethodName = method => method.name === hideEmptyStars.name;
        const yotpoCallbacks = yotpo.allWidgetsReadyCallback;
        const shouldAddCallback =
          yotpoCallbacks && yotpoCallbacks.filter(checkMethodName).length === 0;
        if (shouldAddCallback) {
          yotpo.allWidgetsReadyCallback.push(hideEmptyStars);
        }
        yotpo.initWidgets();
      }, 0);
    }
    /* eslint-enable no-undef */
  }

  handleClickViewAll(e) {
    e.preventDefault();

    RouteHandler.navigate(ShopViewConstants.PRODUCT_LISTING);
    ScrollWidgetActions.scrollShopWidget();
  }

  get showError() {
    const { willUseSampleData, useStaticData, error, configError, provisionHasError } = this.props;
    if (willUseSampleData || useStaticData) return false;
    if (provisionHasError) return true;

    return (
      (configError && configError.hasOwnProperty('status')) ||
      (error && error.hasOwnProperty('status'))
    );
  }

  renderProductData(translate) {
    const {
      products,
      renderPrices,
      renderMode,
      shopWidgetSamePage,
      shopWidgetPageId,
      shopWidgetRoute,
      productDataWasLoaded,
      willUseSampleData,
      imageCropMethod,
      featuredProductsImageShape,
      featuredProductsShowBorder,
      showOnlyProductNameToggle,
      domainName,
      shopRoute
    } = this.props;

    const {
      Component: {
        Grid,
        Grid: { Cell }
      }
    } = UX2;
    const ratingsContainerStyles = {
      marginTop: 'xsmall',
      textAlign: 'center'
    };

    let productData;
    if (this.showError) {
      productData = <ErrorMessage message={ translate('products.error_fetching_product_data') } />;
    } else if (!willUseSampleData && !productDataWasLoaded) {
      return null;
    } else if (products && products.length) {
      const colSize = products.length === 4 ? '6' : '4';
      const productItem = products.map(product => {
        return (
          <Cell key={ product.slug } xs={ 12 } sm={ colSize } style={{ marginBottom: 'large' }}>
            <ProductGroupItem
              productItemAs={ UX2.Component.CommerceCardItem }
              product={ product }
              renderPrices={ renderPrices }
              renderMode={ renderMode }
              shopWidgetSamePage={ shopWidgetSamePage }
              shopWidgetPageId={ shopWidgetPageId }
              shopWidgetRoute={ shopWidgetRoute }
              imageCropMethod={ imageCropMethod }
              imageShape={ featuredProductsImageShape }
              hasImageBorder={ featuredProductsShowBorder }
              showOnlyProductName={ showOnlyProductNameToggle }
              ratings={
                <ProductStarRating
                  product={ product }
                  containerStyle={ ratingsContainerStyles }
                  renderMode={ renderMode }
                  domainName={ domainName }
                  shopRoute={ shopRoute }
                />
              }
            />
          </Cell>
        );
      });

      if (products.length === 4) {
        productData = (
          <Grid size={ 12 } style={{ justifyContent: 'center' }}>
            <Cell xs={ 12 } sm={ 8 }>
              <Grid children={ productItem } size={ 12 } />
            </Cell>
          </Grid>
        );
      } else {
        productData = (
          <Grid size={ 12 } children={ productItem } style={{ justifyContent: 'center' }} />
        );
      }
    } else {
      productData = <NoProducts />;
    }
    return productData;
  }

  render() {
    const {
      fetching,
      products,
      willUseSampleData,
      renderMode,
      shopWidgetSamePage,
      shopWidgetPageId,
      shopWidgetRoute,
      translate
    } = this.props;
    const productData = this.renderProductData(translate);
    const { Block } = UX2.Element;

    return (
      <Block>
        <YotpoCSS products={ products } />
        <Block data-route=''>
          { productData }
          <BottomLinks
            translate={ translate }
            productsLength={ products.length }
            renderMode={ renderMode }
            shopWidgetSamePage={ shopWidgetSamePage }
            shopWidgetPageId={ shopWidgetPageId }
            shopWidgetRoute={ shopWidgetRoute }
            handleClickViewAll={ this.handleClickViewAll }
          />
        </Block>
        <Fetching fetching={ fetching } willUseSampleData={ willUseSampleData } />
      </Block>
    );
  }
}

ClassicLayout.propTypes = {
  products: PropTypes.array,
  imageCropMethod: PropTypes.string,
  featuredProductsImageShape: PropTypes.string,
  featuredProductsShowBorder: PropTypes.bool,
  showOnlyProductNameToggle: PropTypes.bool,
  error: PropTypes.object,
  configError: PropTypes.object,
  renderPrices: PropTypes.any,
  renderMode: PropTypes.string,
  shopWidgetSamePage: PropTypes.bool,
  shopWidgetPageId: PropTypes.any,
  shopWidgetRoute: PropTypes.any,
  productDataWasLoaded: PropTypes.bool,
  fetching: PropTypes.bool,
  willUseSampleData: PropTypes.bool,
  useStaticData: PropTypes.bool,
  provisionHasError: PropTypes.bool,
  domainName: PropTypes.string,
  shopRoute: PropTypes.string,
  translate: PropTypes.func
};

ClassicLayout.defaultProps = {
  products: [],
  configError: null,
  willUseSampleData: false,
  provisionHasError: false,
  useStaticData: false,
  translate: () => {}
};

export default mapContextToProps(ClassicLayout, context => ({
  translate: context.translate
}));
